import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import "../HelpandSupport/PaymentDispute.css";
import { getUserById, sendSupport } from "../api/api";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  // transactionId: Yup.string().required("Transaction ID is required"),
  title: Yup.string().required("Title is required"),
  issue: Yup.string().required("Issue description is required"),
});

const PaymentDispute = () => {
  const [userdata, setUserdata] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const getUserdata = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const _id = userData?.id || userData?._id;
        if (_id) {
          const currentUser = await getUserById({ user_id: _id });
          setUserdata(currentUser);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    getUserdata();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userdata?.data?.name || "",
      email: userdata?.data?.email || "",
      transactionId: "",
      title: "",
      issue: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        const userData = JSON.parse(localStorage.getItem("currentUser"));
        const _id = userData?.id || userData?._id;

        const requestData = {
          user_id: _id,
          user_name: userdata?.data?.name,
          user_email: userdata?.data?.email,
          message: values.issue,
          subject: "pd",
          title: values.title,
          transaction_id: values.transactionId,
        };

        const response = await sendSupport(requestData);

        if (response?.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: response.message,
          }).then(() => {
            navigate("/Sidebar/helpandsupport");
            resetForm();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.message || "Something went wrong",
            confirmButtonColor: "#e04a48",
          });
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to submit request. Please try again later.",
          confirmButtonColor: "#e04a48",
        });
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="form-container">
      <h2>Payment Dispute Form</h2>
      <form onSubmit={formik.handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled
        />
        {formik.touched.name && formik.errors.name && (
          <div className="error">{formik.errors.name}</div>
        )}

        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled
        />
        {formik.touched.email && formik.errors.email && (
          <div className="error">{formik.errors.email}</div>
        )}

        <input
          type="text"
          name="transactionId"
          placeholder="Transaction ID (Optional)"
          value={formik.values.transactionId}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.transactionId && formik.errors.transactionId && (
          <div className="error">{formik.errors.transactionId}</div>
        )}

        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.title && formik.errors.title && (
          <div className="error">{formik.errors.title}</div>
        )}

        <textarea
          name="issue"
          placeholder="Describe Your Issue"
          rows="6"
          value={formik.values.issue}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.issue && formik.errors.issue && (
          <div className="error">{formik.errors.issue}</div>
        )}

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit Dispute"}
        </button>
      </form>
    </div>
  );
};

export default PaymentDispute;
